export default __webpack_public_path__ + "static/media/spider lashes.44385ad3.png";